<template>
  <div id="app">
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <router-view/>
  </div>
</template>
<script>
	export default{
		name:'app',
		data() {
			return{
				
			}
		},
		created() {
			function isMobile(){
				if(window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
				  return true; 
				}else{
				  return false;
				}
			}
			//    判断后的操作
			if(isMobile()){
				location.href="http://h5.xbjgjq.cn/#/"
			}else{
				
			}
		}
	}
</script>
<style>
	body::-webkit-scrollbar {
	display: none;
	}
</style>
<style lang="less">
*{
	margin: 0;
	padding: 0;
}
#app{
		cursor:pointer;
	}
	@font-face {
	  font-family: 'li';
	  src: url('font/LiXuKeShuFa-1.ttf') format("truetype");
	}
	@font-face {
	  font-family: 'wang';
	  src: url('font/王羲之书法字体.ttf') format("truetype");
	}
</style>
